import { helpers } 		from './webtero/helpers.js';
// import { example } 	from './webtero/components/exapmple.js';

window.webtero = {
	globals: {},

	init: function () {
		var self = this;

		self.sellerModal();


		setTimeout(() => {
			if( jQuery( '[data-map-markers]' ).length ) {
				jQuery( '[data-map-markers]' ).each(function() {
					let markers =  jQuery(this).data( 'map-markers' );
					for (let i = 0; i < markers.length; i++) {
						let type = markers[i].type;
						let postId = markers[i].id;

						// let iconLink = "https://applia.test/wp-content/uploads/2024/01/location-3.svg"
;
						// jQuery( this ).find( '.leaflet-marker-pane img').eq(i).attr('src', iconLink);
						jQuery( this ).find( '.leaflet-marker-pane img').eq(i).attr('data-postid', postId) ;
						jQuery( this ).find( '.leaflet-marker-pane img').eq(i).attr('data-show-seller', postId) ;
						
					}
				});
			}
		}, 0);




		
		const textElement1 = document.querySelector('.js-scrollHeading-1');
		const textElement2 = document.querySelector('.js-scrollHeading-2');
		if( textElement1 ) {
			const windowWidth = window.innerWidth;
		
			window.addEventListener('scroll', () => {
				const scrollPos = window.scrollY;
				const maxScroll = document.body.scrollHeight - window.innerHeight;
		
				const scrollPercent = scrollPos / maxScroll;
		
				const newMarginLeft = scrollPercent * windowWidth;
				if(window.innerWidth < 576) {

					textElement1.style.marginLeft = newMarginLeft - windowWidth / 2 * 0.6 + 'px';
					textElement2.style.marginLeft = newMarginLeft - windowWidth / 2 * 0.6 + 'px';
				}
				else {
					textElement1.style.marginLeft = newMarginLeft - windowWidth / 2 * 1 + 'px';
					textElement2.style.marginLeft = newMarginLeft - windowWidth / 2 * 1 + 'px';
				}
			});
		}



		const inputField = document.querySelector('.js-searchName'); // replace with your input field's ID
		const sellers = document.querySelectorAll('.js-seller');

		if( inputField && sellers.length) {
			inputField.addEventListener('input', function() {
		
				let found = false;

				
				sellers.forEach(seller => {
					let seller_id = seller.getAttribute( "data-id" ); 

					if (seller.innerText.toLowerCase().includes( this.value.toLowerCase() ) ) {
						found = true;
						seller.parentElement.classList.remove('d-none');
					
						document.querySelector( '[data-show-seller="' + seller_id + '"]' ).classList.remove('d-none');
					}
					else{
						seller.parentElement.classList.add('d-none');

						document.querySelector( '[data-show-seller="' + seller_id + '"]' ).classList.add('d-none');
					}
				});

				if( found == true ) {
					document.querySelector( '.js-nuffin' ).classList.add('d-none');
				}
				else {
					document.querySelector( '.js-nuffin' ).classList.remove('d-none');
				}
			});
		}




		const cursorDiv = document.querySelector('.cursor');

		function updateCursorDivPosition(e) {
		  cursorDiv.style.left = e.pageX + 'px';
		  cursorDiv.style.top = e.pageY + 'px';
		}
	  
		document.querySelectorAll('.brands__one').forEach(function(element) {
		  element.addEventListener('mouseenter', function() {
			cursorDiv.style.display = 'block';
			document.addEventListener('mousemove', updateCursorDivPosition);
		  });
	  
		  element.addEventListener('mouseleave', function() {
			cursorDiv.style.display = 'none';
			document.removeEventListener('mousemove', updateCursorDivPosition);
		  });
		});




		

		function updateCursorDivPosition(e) {
			cursorDiv.style.left = (e.pageX) + 'px';
			cursorDiv.style.top = (e.pageY) + 'px';
		  }
		
		  const cursorItems = document.querySelectorAll('[data-cursor-text], .slide');

		  if( cursorItems.length ) {
		  cursorItems.forEach(function(element) {
			element.addEventListener('mouseenter', function(e) {

			  if( element.classList.contains('slide') ) {

				if( element.classList.contains('tns-slide-active') ) {
					return;
				}

				hoverText = "DALŠÍ SLIDE";
			
				if (element.closest('.large-slider')) {
					cursorDiv.classList.add('cursor--dark');
				}
			  }
			  else {
				var hoverText = e.target.getAttribute('data-cursor-text');
			  }

			  cursorDiv.textContent = hoverText;

			  cursorDiv.style.display = 'block';
			  document.addEventListener('mousemove', updateCursorDivPosition);
			});
		
			element.addEventListener('mouseleave', function() {
			  cursorDiv.style.display = 'none';
			  cursorDiv.classList.remove('cursor--dark');
			  document.removeEventListener('mousemove', updateCursorDivPosition);

			});
		  });
		}


		if( jQuery( '.js-product-slider' ).length ) {
			jQuery( '.js-product-slider:not(.tns-slider)' ).each(function() {

				let slider = tns({
					container: this,
					items: 1,
					loop: false,
					mouseDrag: true,
					controls: true,

					speed: 400,
					responsive: {
						300: {
							autoHeight: true,
						},
						1024: {
							autoHeight: false,
						}
					}
				});
			});
		}



		function resetTimer() {
			return;
			var timerBar = document.getElementById('timer-bar');

			console.log( timerBar );
			timerBar.style.width = '0'; // Resetuje lištu
			setTimeout(function() {
				timerBar.style.width = '100%'; // Naplní lištu během přechodového intervalu
			}, 10); // Malé zpoždění pro resetování CSS přechodu
		}


		if( jQuery( '.js-large-slider' ).length ) {
			jQuery( '.js-large-slider:not(.tns-slider)' ).each(function() {

				let slider = tns({
					container: this,
					items: 1,

					loop: true,
					mouseDrag: true,
					controls: true,

					//autoplay: true,
					// autoplayTimeout: 4000,
					// autoplayButtonOutput: false,


					speed: 400,
					responsive: {
						300: {
							autoHeight: true,
						},
						1024: {
							autoHeight: false,
						}
					}
				});

				slider.events.on('transitionStart', resetTimer);
			});
		}

		// jQuery( document ).on('change', '.js-typeFilter', function() {
		// 	jQuery( '.js-seller' ).parent().removeClass('show-type');

		// 	jQuery( '.js-typeFilter' ).each(function() {
		// 		if( jQuery( this).is(':checked') ) {
		// 			let typeValue = jQuery( this ).attr( 'value' );
		// 			jQuery( '[data-type*="'+typeValue+'"]').parent().addClass('show-type');
		// 		}
		// 	});

		// 	if(  !jQuery( '.js-typeFilter' ).is( ':checked' ) ) {
		// 		jQuery( '.js-seller' ).parent().addClass('show-type');
		// 	}

		// 	self.checkSelers();
		// 	self.checkMap();
		// });



		// jQuery( document ).on('click', '.js-resetFilter', function(e) {
		// 	e.preventDefault();

		// 	jQuery( '.js-typeFilter').prop( 'checked', false );
		// 	jQuery( '.js-pscFilter').val("");
		// 	jQuery( '.js-seller' ).parent().addClass('show-psc');
		// 	jQuery( '.js-seller' ).parent().addClass('show-type');
			

		// 	self.checkSelers();
		// 	self.checkMap();
		// });


	// 	jQuery( document ).on('click', '.js-filterPSC', function() {
	// 		let pscValue = jQuery( '.js-pscFilter' ).val();
	// 		pscValue = pscValue.replaceAll( " ", "" );

	// 		jQuery( '.js-psc_error' ).removeClass( 'active' );	
	// 		if( pscValue.length != 5 || isNaN( pscValue ) ) {
	// 			jQuery( '.js-psc_error' ).addClass( 'active' );	
	// 			return;
	// 		} 

	// 		jQuery.ajax({
	// 			type: "POST",
	// 			url: sikmoVars.ajax_url,
	// 			data: {zip:pscValue, action:'psc_lats', key:'sL56KYSOBD6flebVBKcFJfY7dniz23i7nCiBKlKA7qyWuc'},

	// 			success: function( data ){
	// 				let search_lat =  data.data.lat;
	// 				let search_lng =  data.data.lng;
					
	// 				jQuery( '.js-seller' ).each(function() {
	// 					let seller_lat = jQuery( this ).data('lat');
	// 					let seller_lng = jQuery( this ).data('lng');

	// 					let distance = self.calcCrow( search_lat, search_lng, seller_lat, seller_lng ).toFixed(1);

	// 					jQuery( this ).parent().attr('data-distance', distance);
	// 					jQuery( this ).find('.d-none').removeClass('d-none');
	// 					jQuery( this ).find('.js-distance').text( distance + " km" );
	// 				});


	// 				var $wrapper = jQuery('.js-sellersList .row');

	// 				$wrapper.find('[data-distance]').sort(function (a, b) {
	// 					return +a.dataset.distance - +b.dataset.distance;
	// 				})
	// 				.appendTo( $wrapper );
	// 			}
	// 		});
	// 	});
	// },

	// calcCrow( lat1, lon1, lat2, lon2 ) {
	// 	var self = this;

	// 	var R = 6371; // km
	// 	var dLat = self.toRad(lat2-lat1);
	// 	var dLon = self.toRad(lon2-lon1);
	// 	var lat1 = self.toRad(lat1);
	// 	var lat2 = self.toRad(lat2);

	// 	var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
	// 		Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
	// 	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
	// 	var d = R * c;
	// 	return d;
	// },

	// toRad( Value )  {
    //     return Value * Math.PI / 180;
    },

	// checkSelers() {
	// 	if( jQuery( '.show-psc.show-type' ).length == 0 ) {
	// 		jQuery( '.js-nuffin' ).removeClass('d-none').addClass('d-block');
	// 	}
	// 	else {
	// 		jQuery( '.js-nuffin' ).addClass('d-none').removeClass('d-block');;
	// 	}
	// },

	checkMap() {
		jQuery( '[data-postid]').hide();
		jQuery( '.show-psc.show-type' ).each(function() {
			let postId = jQuery( this ).find('.js-seller').data('id');
			jQuery( '[data-postid="'+postId+'"]' ).show();
		});
	},

	showSellerModal(seller_id) {
		jQuery.fancybox.open({
			src: `.seller-modal-${seller_id}`,
			type: 'inline',
			touch: false,
			autoFocus: false,
		});
	},

	sellerModal() {
		var self = this;

		jQuery( document ).on('click', '[data-show-seller]', function(e) {
			e.preventDefault();
			e.stopPropagation();

			let seller_id = jQuery( this ).data( 'show-seller' );

			if( jQuery(`.seller-modal-${seller_id}`).length ) {
				self.showSellerModal( seller_id );
				return
			}

			jQuery.ajax({
				type: "POST",
				url: sikmoVars.ajax_url,
				data: {id:seller_id, action:'sellerModal', key:'lm02nxYKEHw67oX9PaBfO6j0UHIIuJ3O'},
				success: function(data){
					jQuery( '.js-sellersModals' ).append( data.data.modal );
					self.showSellerModal( seller_id );
				}
			});
		});
		
	},

	onresize() {
		var self = this;
	},

	onscroll(position, previusPosition) {
		var self = this;
	},
};

jQuery(document).ready(function ($) {
	webtero.init();
});

window.addEventListener('scroll', function (e) {
	webtero.onscroll();
});

window.addEventListener('resize', function (e) {
	webtero.onresize();
});